import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import { getExerciseHistory, formatExerciseLog } from '../lib/exerciseStats'

const UNIT_LABEL = { time: (entry) => (entry.unit === 'sec' ? 'SEC' : 'MIN'), rounds: () => 'ROUNDS', 'weight-reps': () => 'KG' }

export default function ExerciseHistoryChart({ exerciseName, logs, onClose }) {
  const history = getExerciseHistory(logs, exerciseName)
  const firstEntry = history[0]?.entry
  const unitLabel = firstEntry ? (UNIT_LABEL[firstEntry.type] || UNIT_LABEL['weight-reps'])(firstEntry) : 'KG'

  return (
    <div className="exercise-history-panel">
      <div className="exercise-history-head">
        <span className="exercise-history-title">{exerciseName} · TREND</span>
        <button type="button" className="exercise-history-close" onClick={onClose} aria-label="Close">×</button>
      </div>
      {history.length < 2 ? (
        <p className="card-subtitle">Log this exercise on a few more days to see a trend.</p>
      ) : (
        <>
          <div style={{ width: '100%', height: 180 }}>
            <ResponsiveContainer>
              <LineChart data={history} margin={{ top: 8, right: 12, bottom: 0, left: -12 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="var(--h-border)" />
                <XAxis dataKey="day" stroke="var(--h-text-secondary)" fontSize={12} tickLine={false} />
                <YAxis stroke="var(--h-text-secondary)" fontSize={12} tickLine={false} domain={['dataMin - 1', 'dataMax + 1']} />
                <Tooltip
                  contentStyle={{ background: 'var(--h-surface)', border: '1px solid var(--h-border)', borderRadius: 8 }}
                  labelStyle={{ color: 'var(--h-text)' }}
                  labelFormatter={(d) => `Day ${d}`}
                  formatter={(_v, _n, props) => [formatExerciseLog(props.payload.entry), 'Logged']}
                />
                <Line type="monotone" dataKey="metric" stroke="var(--h-accent)" strokeWidth={2} dot={{ r: 3, fill: 'var(--h-accent)' }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
          <p className="trend-note">{history.length} LOGGED SESSIONS · Y-AXIS IN {unitLabel}</p>
        </>
      )}
    </div>
  )
}
